$(document).on('change', '[data-tncp-periodoftime="listen"]', function () {
    let $watchElement = $(document).find('[data-tncp-periodoftime="watch"]');
    $watchElement.find('input').val('');
    if ($(this).val() === 'customRange') {
        $watchElement.show();
    } else {
        $watchElement.hide();
    }
    return false;
});